import React, {useEffect, useState} from 'react';
import {EditOutlined, PlusOutlined} from "@ant-design/icons";
import {Button, Form, Input, Modal, Select} from 'antd';
import {ANY_REGEXP, VALID_PROJECT_CODE} from "../Constants";
import {createD365UnfoundProject, updateD365UnfoundProject} from "../../api/d365Api";
global.ASYNC_VALIDATOR_NO_WARNING = 1; // This stops client console with being populated with validator warnings

const UnfoundProjectButton = ({
                                disabled,
                                onCompleted,
                                isEdit,
                                title,
                                record,
                                email,
                                style
                              }) => {
  const FORM_PROJECT_CODE = 'projectCode';
  const FORM_ACTION = 'action';
  const FORM_MAPPING = 'mapProjectCode';

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [form] = Form.useForm();
  const actionSelectWatch = Form.useWatch(FORM_ACTION, form);
  const [mappingState, setMappingState] = useState(true);
  const [mappingPattern, setMappingPattern] = useState(ANY_REGEXP);


  const _manageUnfoundProject = async () => {
    const editAction = isEdit ? "update" : "create";
    try {
      setLoading(true);
      const projectCode = form.getFieldValue(FORM_PROJECT_CODE);
      const action = form.getFieldValue(FORM_ACTION);
      let mapping = form.getFieldValue(FORM_MAPPING);
      if (action === 'IGNORE') {
        mapping = '';
      }
      const response = isEdit ?
        await updateD365UnfoundProject(record.ID, action, mapping, email) :
        await createD365UnfoundProject(projectCode, action, mapping, email);

      onCompleted(response, editAction + 'd');
      if (isEdit) {
        record.action = action;
        record.mapProjectCode = mapping;
      }
    } catch (e) {
      console.error('Could not ' + editAction + ' D365 Expenses Unfound Project');
    } finally {
      setLoading(false);
      setShowModal(false);
      form.resetFields();
    }
  }

  // revalidate Mapping field if Action Select has changed
  useEffect(() => {
    form.validateFields([FORM_MAPPING]);
  }, [form, actionSelectWatch]);


  const _handleActionChange = (action) => {
    switch (action) {
      case 'NONE':
      case 'IGNORE':
        setMappingState(true);
        setMappingPattern(ANY_REGEXP);
        form.setFieldValue(FORM_MAPPING,'');
        break;
      case 'MAP':
        setMappingState(false);
        setMappingPattern(VALID_PROJECT_CODE);
        break;
      default:
        console.log('Incorrect action value');
        break;
    }
  }

  return (
    <>
      <Button onClick={() => {
        _handleActionChange(record.action)
        form.validateFields([FORM_MAPPING])
        setShowModal(true);
      }} disabled={disabled}
              icon={isEdit ? <EditOutlined/> : <PlusOutlined/>} style={style}>
        {title}
      </Button>

      <Modal
        title={(isEdit ? 'Edit' : 'Create') + ' Create Unfound Project'}
        open={showModal}
        onOk={() => setShowModal(false)}
        onCancel={() => setShowModal(false)}
        footer={[
          <Button key='cancel' onClick={() => setShowModal(false)}>Cancel</Button>,
          <Button key='submit' type='primary' disabled={false}
                  onClick={() => form.submit()}
                  loading={loading}>Submit</Button>
        ]}
      >
        <Form
          name={`manage_unfound_project`}
          form={form}
          onFinish={_manageUnfoundProject}
          labelCol={{span: 6}}
        >
          <Form.Item
            label='Project Code'
            name={FORM_PROJECT_CODE}
            initialValue={record.projectCode}
            rules={[{required: !isEdit, pattern: VALID_PROJECT_CODE, message: 'Incorrect Project Code'}]}
          >
            <Input disabled={isEdit}/>
          </Form.Item>
          <Form.Item
            label='Action'
            name={FORM_ACTION}
            initialValue={record.action}
            rules={[{required: true, pattern: new RegExp('^(IGNORE|MAP)$'), message: 'Action NONE is not allowed'}]}
          >
            <Select
              mode='single'
              onChange={_handleActionChange}
            >
              <Select.Option key='NONE' value='NONE'>NONE</Select.Option>
              <Select.Option key='IGNORE' value='IGNORE'>IGNORE</Select.Option>
              <Select.Option key='MAP' value='MAP'>MAP</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label='Mapping'
            name={FORM_MAPPING}
            initialValue={record.mapProjectCode}
            rules={[{required: !mappingState, pattern: mappingPattern, message: 'Incorrect Project Code'},
              ({ getFieldValue}) => ({
                validator(_, value) {
                  if (!value || getFieldValue(FORM_PROJECT_CODE) !== value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Please map to other project code'));
                }
              })]}
          >
            <Input disabled={mappingState}/>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export {UnfoundProjectButton};